import React from "react";
import { useEnigmaToken } from "@hooks/useEnigmaToken";
import { StyledLabel } from "./inputLabel.styles";
import { InputLabelProps } from "./inputLabel.types";

export const InputLabel = ({
    children,
    required,
    ...rest
}: InputLabelProps) => {
    const token = useEnigmaToken();
    return (
        <StyledLabel token={token} required={required} {...rest}>
            {children}
        </StyledLabel>
    );
};

InputLabel.displayName = "InputLabel";
